import styled from 'styled-components';
import CoreGrayButton from 'shared/button/CoreGrayButton';
import { useLogoutMutation } from 'hooks/mutations/user';

const Header = () => {
	const { mutate: logoutMutate, isLoading: logout_loading } = useLogoutMutation();

	return (
		<HeaderBox>
			<Title>IMMS 2.0</Title>
			<CoreGrayButton
				size="default"
				style_type="outlined"
				text="Logout"
				color_type="white"
				is_loading={logout_loading}
				_onClick={() => logoutMutate()}
			/>
		</HeaderBox>
	);
};

const HeaderBox = styled.header`
	width: 100%;
	height: 88px;
	padding: 24px 16px;
	background-color: ${({ theme }) => theme.colors.gray.gray80_text};

	${({ theme }) => theme.common.flexBetween};
`;

const Title = styled.h1`
	${({ theme }) => theme.typo.title.h2};
	color: ${({ theme }) => theme.colors.gray.gray_white};
`;

export default Header;
